import toast from "react-hot-toast";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { MESSAGE_CONTROLER_URL } from "api/Service";
import { getServerErrorMessage } from "utils/showMutationError";
import { stripTransportNoise } from "utils/stripTransportNoise";

export const useSendSmsForPatient = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    // This hook explains its own failures, so the generic "An error occurred.
    // Please try again." from GlobalLayout would only be a second toast saying
    // less than the first.
    meta: { skipGlobalError: true },
    mutationFn: async ({ patientId, message }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}${MESSAGE_CONTROLER_URL}`,
        { tenant: tenantVal, message, patientId }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.success("SMS sent successfully.");
    },
    onError: (error) => {
      console.error(error);
      toast.error(
        stripTransportNoise(
          getServerErrorMessage(
            error,
            "Could not send the SMS. Please try again."
          )
        )
      );
    },
  });
};
